import wixData from 'wix-data';
import wixWindow from 'wix-window';

$w.onReady(function () {
});

export function loadingStrip_viewportEnter(event) {
	$w('#loadingGIf').show();
	$w('#dataset1').loadMore()
		.then(() => {
			$w('#loadingGIf').hide();

			console.log('Done loading more data')
		});
}
// $w.onReady(function () {
// 	$w("#dataset1").onReady(() => {
// 		$w('#firstRepeater').onItemReady(($item, itemData, index) => {
// 			//Button1 expend if has data
// 			let current = $item('#dataset1').getCurrentItem()
// 			let title = current.title;
// 			wixData.query("Lights")
// 				.eq("title", title)
// 				.isNotEmpty("marmelada")
// 				.find()
// 				.then((results) => {
// //					console.log(results);
// 					if (results.items.length > 0) {
// 						$item('#button1').show();
// 					} else {
// 					//show order button
// 					$item('#orderBTN').show();
// 					}
// 				})
// 				.catch((error) => {
// 					let errorMsg = error.message;
// 					let code = error.code;
// 				});
// 		});
// 	});
// });

//----------------------------------------------------------
//                  OPEN LIGHTBOX
//----------------------------------------------------------
export function container1_click(event, $w) {

}
export function orderBTN_click(event, $w) {
//	$w('#firstRepeater').onItemReady(($item, itemData, index) => {
		let lightBolb = $w('#dataset1').getCurrentItem()
		console.log(lightBolb)
		wixWindow.openLightbox("התעניינות בגוף תאורה", {
		"productIDsend": lightBolb._id,
		
	})

}

